const FilterDropdownMenuWrapper = (props, { slots }) => {
    var _a;
    return (<div class={props.class} onClick={e => e.stopPropagation()}>
      {(_a = slots.default) === null || _a === void 0 ? void 0 : _a.call(slots)}
    </div>);
};
FilterDropdownMenuWrapper.inheritAttrs = false;
export default FilterDropdownMenuWrapper;
